var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('bread-crumbs',{attrs:{"items":_vm.breadcrumbs}}),_c('h2',{staticClass:"text-h5 font-weight-bold mb-4"},[_vm._v(" Áreas de "+_vm._s(_vm.cliente.nombre)+" ")]),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":[
      { text: 'ID',     value: 'id'     },
      { text: 'Nombre', value: 'nombre' }
    ],"items":_vm.areas},on:{"click:row":_vm.goToProyectos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }